<template lang='pug'>
  include ./../../mixins
  div
    //- +b.close-modal.fs_md.color_main-3.mdi.mdi-close.cursor-pointer.BUTTON(@click='toggleHandler')
    +b.fs_3md.font-weight_medium.margin_bottom_md.H3 {{_('Password Changing Title')}}
    change-password(
      @close-modal='toggleHandler()'
    )
</template>

<script>
export default {
  name: "PasswordModal",
  methods: {
    toggleHandler() {
      this.$modal.hide("PasswordModal")
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/js/components/Modals/PasswordModal.vue